module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/icon-area-556ec830018c496b0e766e73607aae36.webp";